import { match } from 'ts-pattern';

import { TUser } from '@cloud-wave/neon-common-lib';

export function getInteractionsTooltipProps(onContact?: TUser['onContact']): {
  text: string;
  iconColor: string;
  textColor: string;
} {
  return match(onContact)
    .with(null, () => ({
      text: 'No active interactions',
      iconColor: 'darkGrey',
      textColor: 'darkGrey',
    }))
    .otherwise(() => ({
      text: 'Handling interactions',
      iconColor: 'darkBlue',
      textColor: 'black',
    }));
}
